import React, { useContext, useState } from 'react';

import { Grid, Skeleton, Table, TableRow, TableCell, TableBody } from '@mui/material';
import styled from 'styled-components';
import { useContainer } from 'unstated-next';

import ClassSessionsStudentToolbar from './ClassSessionsStudentToolbar';
import AdminAuthContainer from '../../../AdminAuthContainer';
import { ClassSessionContext } from '../../../ClassSessionContext';
import { CloudWatchLogProvider } from '../../../CloudWatchLogContext';
import { CloudWatchLogsView } from '../../CloudWatchLogsView';

const Spacer = styled.div`
    margin: 1rem;
`;

const PaddedSkeleton = styled(Skeleton)`
    margin: 0.5rem 0;
`;

export const ClassSessionDetailLog = () => {
    const { classSessionLog, classSessionData } = useContext(ClassSessionContext);
    const { authMode } = useContainer(AdminAuthContainer);
    console.log('ClassSessionDetailLog classSessionLog', classSessionLog, 'authMode', authMode);

    const [searchText, setSearchText] = useState('');

    const handleChangeSearch = (event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
        setSearchText(event.target.value);
    };

    if (!classSessionLog || classSessionLog.loading) {
        return (
            <>
                <Grid container justifyContent="space-between">
                    <Grid item>
                        <Skeleton width={300} height={60} />
                    </Grid>
                    <Grid item>
                        <Skeleton width={150} height={60} />
                    </Grid>
                </Grid>
                <Spacer />
                <PaddedSkeleton height={35} />
                <PaddedSkeleton height={35} />
                <PaddedSkeleton height={35} />
                <PaddedSkeleton height={35} />
                <PaddedSkeleton height={35} />
                <Spacer />
                <Grid container justifyContent="flex-end">
                    <Skeleton width={400} height={50} />
                </Grid>
            </>
        );
    }

    return (
        <>
            <Table style={{ width: '100%', padding: '0px', margin: '0px' }}>
                <TableBody style={{ width: '100%', padding: '0px', margin: '0px' }}>
                    <TableRow style={{ width: '100%', padding: '0px', margin: '0px' }}>
                        <TableCell style={{ borderBottom: 'none' }}>
                            <ClassSessionsStudentToolbar
                                searchText={searchText}
                                handleChangeSearch={handleChangeSearch}
                            />
                        </TableCell>
                    </TableRow>
                </TableBody>
            </Table>
            {classSessionData && (
                <CloudWatchLogProvider
                    style={{ height: '600px', maxHeight: '600px', overflowY: 'auto' }}
                    primaryQuery={`meeting_id:${classSessionData.class.meeting_id}`}
                    secondaryQuery={searchText}
                    startTime={Number(classSessionData.start_time) - 1000 * 60 * 5}
                    endTime={Number(classSessionData.end_time) + 1000 * 60 * 5}
                    setSearchText={setSearchText}
                >
                    <CloudWatchLogsView />
                </CloudWatchLogProvider>
            )}
        </>
    );
};
